'use client';

import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import LoadingLink from '@/components/ui/LoadingLink/LoadingLink';
import { ShueishaIdAuthType } from '@/features/account/types';
import { goShueishaIdAuth } from '@/features/auth/utils';
import { useGlobalLoadingAtom } from '@/state';
import utilsStyles from '@/styles/modules/utils.module.scss';
import type { Session } from 'next-auth';
import styles from './ContactHeader.module.scss';

function ContactHeader({ session }: { session: Session | null }) {
  const [_, startGlobalLoading] = useGlobalLoadingAtom();
  return (
    <>
      <div className={`${utilsStyles.gfMtMedium} ${styles.headerContainer}`}>
        <PageHeader text='CONTACT' size='medium' />
      </div>
      <div className={utilsStyles.mtSmall}>
        {!session && (
          <p className={utilsStyles.textSmall}>
            すでに「ジャンプLAB」をご利用の方はログインしてから問い合わせを行いますと調査および回答がスムーズになります。（
            <button
              type='button'
              className={`${utilsStyles.textUnderlined} ${styles.loginButton}`}
              onClick={async () => {
                startGlobalLoading();
                await goShueishaIdAuth({
                  type: ShueishaIdAuthType.auth,
                  callbackPagePath: '/contact',
                });
              }}
            >
              ログインはこちら
            </button>
            ）
          </p>
        )}
        <div className={utilsStyles.rightJustified}>
          <LoadingLink href={'/account/contact-history'} className={`${utilsStyles.textSmall} ${utilsStyles.textLink}`}>
            返信一覧
          </LoadingLink>
        </div>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
          お問い合わせ内容を担当者が確認したのち、順次返信させていただきます。
          <br />
          （通常2〜3営業日程度）
          <br />
          なお、土日祝日および長期休暇中のお問い合わせへの返信は通常よりもお時間をいただく可能性がございますので、予めご了承くださいませ。
        </p>
        <p className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
          お問い合わせ前に
          <LoadingLink href={'/faq'} className={utilsStyles.textLink}>
            FAQ
          </LoadingLink>
          をご確認お願いします。
        </p>
      </div>
      <div className={utilsStyles.mtSmall} />
    </>
  );
}

export default ContactHeader;
